import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PersonApiClient } from 'src/app/services/api-clients/person.api-client';
import { RequestModel } from 'src/app/models/requests';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { User } from 'src/app/models/user';
import { BehaviorSubject, lastValueFrom, Subscription } from 'rxjs';
import { DocumentActor } from 'src/app/models/actors';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ViewportScroller } from '@angular/common';
import { DocumentApiClient } from 'src/app/services/document.apiclient';
import { PkisigningService } from 'src/app/services/pkisigning.service';
import { HttpErrorResponse } from '@angular/common/http';
import { PdfSignatureData } from 'src/app/models/pdfsignaturedata';
import { EngineSignatureField } from "src/app/models/EngineSignatureField";
import { DossierService } from 'src/app/services/dossier.service';
import { TranslateParser, TranslateService } from '@ngx-translate/core';
import { PerformActionDocumentPdfComponent } from './performactiondocumentpdf/performactiondocumentpdf.component';
import { PerformActionAuthenticateComponent } from './performactionauthenticate/performactionauthenticate.component';
import { PerformActionDocumentRenderingComponent } from './performactiondocumentrendering/performactiondocumentrendering.component';
import { SignatureProvider } from 'src/app/models/signatureProvider';
import { ToastService } from 'src/app/services/toast.service';
import { DocumentIsLockedModel, DocumentModel } from 'src/app/models/document.model';
import { RequestApiClient } from 'src/app/services/request.apiclient';
import { SignatureField } from 'src/app/models/signaturefield';
import { LoggingService } from 'src/app/services/logging.service';
import { PerformActionPendingModal } from './modals/perform-action-pending/perform-action-pending.modal';
import { PerformactioncertificatesComponent } from './performactioncertificates/performactioncertificates.component';
import { StringHelper } from 'src/app/directives/string-helper';
import { PerformActionConstants } from './perform-action.constants';
import { ChangesignatureproviderModal } from './changesignatureprovider/changesignatureprovider.modal';
import { StatusEnum } from 'src/app/constants/status.enum';
import { EngineApiClient } from 'src/app/services/api-clients/engine.api-client';
import { Is_Sign_Action } from 'src/app/constants/actor-action.enum';
import { PerformActionSignModal } from './modals/perform-action-sign.modal/perform-action-sign.modal';
import { DisplayRequestUnavailableModal } from './modals/display-request-unavailable.modal/display-request-unavailable.modal';
import { ViewerModalService } from './viewer-modal.service';
import { ViewerService } from './viewer.service';
import { ViewerDataService } from './viewer-data.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { ReauthenticationDetailsModel } from 'src/app/models/api/reauthentication-details.model';
import { IdentificationVerificationApiClient } from 'src/app/services/api-clients/identification-verification.api-client';
import { ViewerHubService } from 'src/app/services/viewerhub.service';
import { ExistsIn, SingleOrDefault } from 'src/app/_helpers/ArrayExtensionMethodHelper.functions';
import { ActorActionsApiClient } from 'src/app/services/api-clients/actor-actions.api-client';


@Component({
  templateUrl: './performaction.page.html'
})
export class PerformActionPage implements OnDestroy, OnInit {

  /** 
   * The request Guid retrieved from the URL, the retrieved Request is the input for this page and all its subsequent components/Modals/Services
   */
  RequestId!: string;
  // Display booleans:
  displayAsDownloadPage = false;
  displayAsPerformActionPage = true;
  /**
   * this bool helps in PREVENTING signalR or later updates to change/refresh the page.
   * This SHOULD be set true when switching to:
   * - Download page
   * - All actions completed page
   * - returning to the page after completing all acitons
   */
  isShowingAFinalPage = false;

  // Needed subscriptions:
  private routeParamSubscription!: Subscription;
  private userSubscription!: Subscription;
  private requestSubscription: Subscription;
  private documentLockedSubscription: Subscription;
  private documentUnlockedSubscription: Subscription;
  private actionUpdatedSubscription: Subscription;
  private currentActorSubscription: Subscription;

  /**
   * Whether after completion of an action you should be navigated to the nextG
   * default value is misleading, since we listen to Service and it is Behavior so sends its initial value
   */
  navigateToNextActionAfterCompletion = false;
  actorForNavigation: DocumentActor | null = null;

  stringHelper = new StringHelper();
  request: RequestModel = {} as RequestModel;
  dossierPersonId!: string;
  actor!: DocumentActor;
  /**
   * Retrieved Actor InviteId for Signing
   */
  currentActorInviteId!: string;

  user!: User;
  allActors: DocumentActor[] = [];
  userActors: DocumentActor[] = [];
  actions: DocumentActor[] = [];
  actionsOtherActors: DocumentActor[] = [];
  attachments: DocumentModel[] = [];
  owner!: string;
  PDFDocument: any = { filetype: '.PDF' };
  XBRLDcoument: any = { filetype: '.XBRL' };
  //completed: boolean = false;
  signingSession: any;
  documentId!: string;
  private pkisSubscription!: Subscription;
  showDownloadButton: boolean = false;
  public listSignatureProviders: [] = [];
  signatureProviderUrl!: string;
  errorTitle: string | undefined;
  errorDescription: string | undefined;
  buttonsEnabled: BehaviorSubject<boolean>;
  rejectionReason!: string;
  modalRef!: NgbModalRef;
  stampImage!: string;
  pendingStatus: string = '';
  translations = <any>{};
  @ViewChildren('performactiondocumentpdf')
  public performactiondocumentpdf!: QueryList<PerformActionDocumentPdfComponent>;
  @ViewChildren('performactiondocumentrendering')
  public performactiondocumentrendering!: QueryList<PerformActionDocumentRenderingComponent>;
  providerLogoList: any = [];
  /**
   * PROVIDER that will be used for signing
   */
  selectedSignatureProvider!: SignatureProvider;
  /**
   * PROVIDER that will be used for selecting/validation
   */
  currentSignatureProvider: any;
  identificationModalRef!: NgbModalRef;
  signatureProviderIndex!: number;
  currentProvider!: string;
  suffix!: string;
  eSeal: boolean = false;
  settings: any[] = [];
  showLocation: boolean = false;
  showReason: boolean = false;
  showStamp: boolean = true;
  showDraw: boolean = true;
  showPicture: boolean = true;
  zoomFactor: number = 0;
  columnsLg: number = 9;
  columnsXl: number = 6;
  defaultColumnsLg: number = 9;
  defaultColumnsXl: number = 6;
  defaultOffsetLg: number = 1;
  defaultOffsetXl: number = 2;
  documents: DocumentModel[] = [];
  documentsToShow: DocumentModel[] = [];
  /**
   * when zooming we get and store the Id so we can navigate back to the page
   */
  zoomPageElementId: string | null = null;

  public availableSignatureProviders: any;

  /* Minimal pixels below last page in viewer */
  paddingBelowLastPage: number = 70;





  constructor(
    private oidcSecurityService: OidcSecurityService,
    public viewerService: ViewerService,
    private viewerModalService: ViewerModalService,
    private viewerDataService: ViewerDataService,
    private route: ActivatedRoute,
    public router: Router,
    private dossierService: DossierService,
    private documentService: DocumentApiClient,
    public personService: PersonApiClient,
    private authenticationService: AuthenticationService,
    private engineApiClient: EngineApiClient,
    private modalService: NgbModal,
    private viewportScroller: ViewportScroller,
    private pkisigning: PkisigningService,
    private translateService: TranslateService,
    private toastService: ToastService,
    private translateParser: TranslateParser,
    private requestService: RequestApiClient,
    private loggingService: LoggingService,
    private identificationVerificationApiClient: IdentificationVerificationApiClient,
    private viewerHubService: ViewerHubService,
    private actorActionApiClient: ActorActionsApiClient
  ) {
    let actionPosition = ((document.documentElement.clientHeight / 2) - 24);
    this.viewportScroller.setOffset([0, actionPosition])
    this.buttonsEnabled = new BehaviorSubject<boolean>(true);
    this.getTranslations();
    translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    });
    this.currentActorSubscription = this.viewerDataService.getCurrentActor$().subscribe(currentActor => {
      this.currentActorInviteId = currentActor.id;
    });
    
    this.requestSubscription = this.viewerHubService.viewerRequest$.subscribe(request => {
      // If input request status = StatusEnum.Withdrawn open Withdrawn modal
      if (request.status === StatusEnum.Withdrawn) {
        this.viewerModalService.OpenWithdrawn(request.reasons)
      }
      // If input request status = StatusEnum.Declined open Rejected modal
      else if (request.status === StatusEnum.Declined) {
        this.viewerModalService.OpenRejected(request.reasons)
      }
      // If input request status = StatusEnum.Completed open Completed modal
      else if (request.status === StatusEnum.Completed) {
        this.setViewerToCompleted();
      }
    });

    // PAGE needs to list to these events, since this knows WHEN elements are visible the best
    this.documentLockedSubscription = this.viewerHubService.documentsToLock$.subscribe(documentToLockDetails => {

      // is there something to make the link to YOUR documents for:
      if (!documentToLockDetails.documentGuid) {
        return;
      }
      // lets not make to many links to a 'any' document
      var documentGuidToUse = documentToLockDetails.documentGuid;
      var lockedSecondsToUse = documentToLockDetails.expectedSeconds;
      var forInviteIdToUse = documentToLockDetails.forInviteId;

      // are you not the 'Assumed' Locker:
      if (this.viewerDataService.signStartedForDocument === documentGuidToUse ||
        (this.viewerDataService.actions && ExistsIn(this.viewerDataService.actions, "id", forInviteIdToUse))
      ) {
        return;
      }

      // did i already SHOW a LOCK else no unlock toast
      var alreadyShowedToastWithoutUnlockToast = ExistsIn(this.viewerDataService.listOfToastsWithLockedDocuments, "Guid", documentGuidToUse);
      if (alreadyShowedToastWithoutUnlockToast) {
        return;
      }

      // store that a toast should be shown when field comes into view:
      let docName = SingleOrDefault(this.documents, "id", documentGuidToUse)?.name ?? "";
      let lockedDocumentModel: DocumentIsLockedModel = {
        Guid: documentGuidToUse,
        Name: docName,
        Seconds: lockedSecondsToUse
      };
      this.viewerDataService.runTimerForLockedDocument(lockedDocumentModel);

      // is A button for YOU CURRENTLY visible:
      var isFieldVisible = this.VerifyIfActionButtonIsInView(documentGuidToUse);
      if (!isFieldVisible) {
        this.viewerDataService.listOfLockedDocumentsWithoutToasties.push(lockedDocumentModel);
        //  run special timer, that verifies when doc comes in view 
        this.runTimerForHiddenDocument(lockedDocumentModel);
        return;
      }

      // remove the stored lock if existing:
      this.removeFromStoredHiddenToastIfExisting(documentGuidToUse);

      // execute toast + save for future toasting
      this.showToastAndLockDocumentForFuture(documentGuidToUse, lockedSecondsToUse);

    });

    // THIS IS RETAINED HERE, so it is close to the LOCKING ^
    this.documentUnlockedSubscription = this.viewerHubService.documentsToUnlock$.subscribe(documentGuid => {
      // was it MY locking, release it:
      if (this.viewerDataService.signStartedForDocument === documentGuid) {
        this.viewerDataService.signStartedForDocument = null;
      }

      // remove the stored lock:
      this.removeFromStoredHiddenToastIfExisting(documentGuid);
      // did i SHOW a LOCK else no unlock toast
      var lockedDocumentInfo = SingleOrDefault(this.viewerDataService.listOfToastsWithLockedDocuments, "Guid", documentGuid);
      // IF document was locked:
      if (lockedDocumentInfo) {
        this.toastService.singleDocumentUnlocked(lockedDocumentInfo.Name);
        // remove the toast locking
        this.viewerDataService.listOfToastsWithLockedDocuments.splice(this.viewerDataService.listOfToastsWithLockedDocuments.findIndex(doc => doc.Guid === documentGuid), 1);
      }
    });

    this.actionUpdatedSubscription = this.viewerHubService.actionUpdated$.subscribe(inviteGuid => {
      let action = SingleOrDefault(this.viewerDataService.allActors, "id", inviteGuid);
      if (!action) {
        return;
      }
      let currentPdf: PerformActionDocumentPdfComponent | undefined = this.performactiondocumentpdf.find(s => s.document.id === action.documentId);
      if (!currentPdf) {
        return;
      }
      currentPdf.reloadSignaturePage(action.sigFieldPage);
    })

  }

  public runTimerForHiddenDocument(document: DocumentIsLockedModel) {
    let checkVisibleInterval = setInterval(() => {
      // your document is no longer in the locked arrays
      if (!ExistsIn(this.viewerDataService.listOfToastsWithLockedDocuments, "Guid", document.Guid) && !ExistsIn(this.viewerDataService.listOfLockedDocumentsWithoutToasties, "Guid", document.Guid)) {
        clearInterval(checkVisibleInterval);
        return;
      }
      var isFieldVisible = this.VerifyIfActionButtonIsInView(document.Guid);
      if (isFieldVisible) {
        if (ExistsIn(this.viewerDataService.listOfLockedDocumentsWithoutToasties, "Guid", document.Guid)) {
          // FIRST TOAST AND SHOW
          this.showToastAndLockDocumentForFuture(document.Guid, document.Seconds);
          // remove the stored lock:
          this.removeFromStoredHiddenToastIfExisting(document.Guid);
        }
        // stop this timer, other is started
        clearInterval(checkVisibleInterval);
      }
    }, 500);
  }

  /**
   * Verifies if the given document has a Locking (without toast)
   * returns AND removes it
   * @param documentGuid 
   * @returns 
   */
  private removeFromStoredHiddenToastIfExisting(documentGuid: string) {
    let hadStoredToast = SingleOrDefault(this.viewerDataService.listOfLockedDocumentsWithoutToasties, "Guid", documentGuid);
    if (hadStoredToast) {
      // remove the toast locking
      this.viewerDataService.listOfLockedDocumentsWithoutToasties.splice(this.viewerDataService.listOfLockedDocumentsWithoutToasties.findIndex(doc => doc.Guid === documentGuid), 1);
    }
  }
  private showToastAndLockDocumentForFuture(documentGuid: string, expectedSeconds: number) {
    // now get Data
    let docName = SingleOrDefault(this.documents, "id", documentGuid)?.name ?? "";
    this.toastService.singleDocumentLockedForSigning(docName);
    let lockedDocumentModel: DocumentIsLockedModel = {
      Guid: documentGuid,
      Name: docName,
      Seconds: expectedSeconds
    };
    this.viewerDataService.listOfToastsWithLockedDocuments.push(lockedDocumentModel);
  }

  private VerifyIfActionButtonIsInView(documentGuid: string): boolean {
    // easier to read/find
    let noUserFieldIsVisible = false;
    let visibleFieldIsFoundForUser = true;
    // lets first check if the doc exists
    let doc = SingleOrDefault(this.request.documentInfo, "id", documentGuid);
    if (!doc || !doc.pages) {
      return noUserFieldIsVisible;
    }
    // now if you have any actions at all
    if (!this.userActors || this.userActors.length == 0) {
      return noUserFieldIsVisible;
    }
    // grab all Actions for given DOCUMENT
    var actionsForDocument = this.userActors.filter(x => x.documentId == documentGuid);
    // do we have sign actions to lock?
    if (actionsForDocument && actionsForDocument.length)
      // loop through
      for (let userActionCount: number = 0; userActionCount < actionsForDocument.length; userActionCount++) {
        // grab model
        let userAction = actionsForDocument[userActionCount];
        // it should exist but meh
        if (userAction) {
          // now lets try and get the Button
          let signaturePlaceholderElement: HTMLElement = <HTMLElement>document.getElementById("signaturePlaceholder_" + userAction.fieldName);
          let visibleField = this.isPartiallyVisible(signaturePlaceholderElement);
          if (visibleField) {
            return visibleFieldIsFoundForUser;
          }
        }
      }
    return noUserFieldIsVisible;
  }

  ngOnDestroy() {
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
    if (this.routeParamSubscription) {
      this.routeParamSubscription.unsubscribe();
    }
    if (this.requestSubscription) {
      this.requestSubscription.unsubscribe();
    }
    if (this.documentLockedSubscription) {
      this.documentLockedSubscription.unsubscribe();
    }
    if (this.documentUnlockedSubscription) {
      this.documentUnlockedSubscription.unsubscribe();
    }
    if (this.actionUpdatedSubscription) {
      this.actionUpdatedSubscription.unsubscribe();
    }
    if (this.currentActorSubscription) {
      this.currentActorSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    // We always need the user
    this.userSubscription = this.authenticationService.currentUser.subscribe((data) => {
      this.user = data;
    });
    // we need to grab the Request Guid from Url params:
    this.routeParamSubscription = this.route.params.subscribe(params => {
      this.RequestId = params['requestId'];
      this.viewerHubService.start(this.RequestId);

      if (!this.RequestId) {
        this.RequestUnavailableDialog();
        return;
      }
      this.identificationVerificationApiClient.MakeVerifyIdentificationCall(this.RequestId).subscribe({
        next: (reAuthorizeDetails: ReauthenticationDetailsModel) => {
          if (reAuthorizeDetails) {
            sessionStorage.setItem("returnUrl", "/view/" + this.RequestId);
            this.oidcSecurityService.authorize(null!, { customParams: { 'acr_values': "idp:" + reAuthorizeDetails.forIdentityProvider, 'login_hint': reAuthorizeDetails.forInviteId } });
          } else {
            // now we can go and retrieve all the data, pass the Id towards the MAIN service
            this.viewerService.InitializeForRequest(this.RequestId);
          }
        }, error: () => {
          // now we can go and retrieve all the data, pass the Id towards the MAIN service
          this.viewerService.InitializeForRequest(this.RequestId);
        }
      });

      // start the LISTENERS:
      this.SubscribeToServiceEvents();
    });
  }
  private SubscribeToServiceEvents() {
    // Let us listen for when the request failed, or should not be accessed
    this.viewerService.requestUnavailable$.subscribe(bool => {
      this.RequestUnavailableDialog();
    });

    // listen for whether we should start navigating through actions
    this.viewerDataService.navigateThroughActions$.subscribe(navigateMe => {
      this.navigateToNextActionAfterCompletion = navigateMe;
    });

    // navigate ON actor change WHEN start button USED
    this.viewerDataService.getCurrentActor$().subscribe((currentActor) => {
      this.actorForNavigation = currentActor;
      if (!this.navigateToNextActionAfterCompletion || !currentActor || currentActor.id == undefined) {
        return;
      }
      this.awaitAndGotoNextAction(currentActor);
    });


    // WHEN initialization is done, we can grab all info for the page from the SHARED service
    this.viewerService.initializationDone$.subscribe(readyForUse => {
      if (readyForUse) {
        this.request = this.viewerDataService.request;
        this.documents = this.viewerDataService.documents;
        this.documentsToShow = this.viewerDataService.documentsToShow;
        this.allActors = this.viewerDataService.allActors;
        this.userActors = this.viewerDataService.userActors;
        this.actionsOtherActors = this.viewerDataService.otherActors;
        this.actions = this.userActors;

        // set signature methodes
        this.showDraw = this.viewerDataService.showDraw;
        this.showPicture = this.viewerDataService.showPicture;
        this.showStamp = this.viewerDataService.showStamp;

        // set reason and location
        this.showLocation = this.viewerDataService.showLocation;
        this.showReason = this.viewerDataService.showReason;

        // documents
        this.documents.forEach(doc => {
          if (doc.documentType.toLocaleLowerCase() == "html") {
            this.getHtml(doc);
          }
        });
      }
    });

    // let us listen for when the 'viewer' should turn into 'downloader'
    this.viewerService.showDownloadPage$.subscribe(() => {
      if (!this.isShowingAFinalPage && !this.viewerService.hasUncompletedActions) {
        this.isShowingAFinalPage = true;
        this.displayAsDownloadPage = true;
        this.showDownloadButton = true;
        this.displayAsPerformActionPage = false;
      }
    });

    // When request is completed, we must turn the VIEWER into a 'Completed'-> Downloader
    this.viewerService.requestCompleted$.subscribe(() => {
      this.setViewerToCompleted();
    });
  }


  getTranslations() {
    this.translateService.get([
      'Request.View.PerformActionComplete.PreparingDocument',
      'Request.View.PerformActionComplete.Signing',
      'Request.View.PerformActionComplete.Signed',
      'Request.View.PerformActionComplete.ErrorStartingSignflow',
      'Request.View.PerformActionComplete.GivePermissionQTSPApp',
      'Request.View.PerformActionComplete.PreparingFiling',
      'Request.View.PerformActionComplete.GeneratingSignature',
      'Request.View.PerformActionComplete.GeneratingDetachedCertificate',
      'Error.DefaultErrorTitle',
      'Error.EngineErrorDefault',
      'Error.Engine.FailedDependency',
      'Request.View.SigningDialog.ESeal',
      'Request.View.SigningDialog.Token',
      'Request.View.SigningDialog.TokenAgent',
      'Request.View.SigningDialog.Test',
      'Toasts.RequestsDownloadError',
      'Toasts.GetDocumentError',
      'Toasts.DownloadTitle',
      'Toasts.DownloadBody',
      'Toasts.Error',
      'Request.View.ReceivingEntity.Digipoort',
      'Request.View.ReceivingEntity.SBRNexus'
    ]).subscribe(translation => {
      this.translations.PreparingDocument = translation['Request.View.PerformActionComplete.PreparingDocument'];
      this.translations.Signing = translation['Request.View.PerformActionComplete.Signing'];
      this.translations.Signed = translation['Request.View.PerformActionComplete.Signed'];
      this.translations.ErrorStartingSignflow = translation['Request.View.PerformActionComplete.ErrorStartingSignflow'];
      this.translations.GivePermissionQTSPApp = translation['Request.View.PerformActionComplete.GivePermissionQTSPApp'];
      this.translations.PreparingFiling = translation['Request.View.PerformActionComplete.PreparingFiling'];
      this.translations.GeneratingSignature = translation['Request.View.PerformActionComplete.GeneratingSignature'];
      this.translations.GeneratingDetachedCertificate = translation['Request.View.PerformActionComplete.GeneratingDetachedCertificate'];
      this.translations.DefaultErrorTitle = translation['Error.DefaultErrorTitle'];
      this.translations.EngineErrorDefault = translation['Error.EngineErrorDefault'];
      this.translations.FailedDependency = translation['Error.Engine.FailedDependency'];
      this.translations.ESeal = translation['Request.View.SigningDialog.ESeal'];
      this.translations.Token = translation['Request.View.SigningDialog.Token'];
      this.translations.TokenAgent = translation['Request.View.SigningDialog.TokenAgent'];
      this.translations.Test = translation['Request.View.SigningDialog.Test'];
      this.translations.toastsRequestsDownloadError = translation['Toasts.RequestsDownloadError'];
      this.translations.toastsGetDocumentError = translation['Toasts.GetDocumentError'];
      this.translations.error = translation['Toasts.Error'];
      this.translations.DownloadTitle = translation['Toasts.DownloadTitle'];
      this.translations.DownloadBody = translation['Toasts.DownloadBody'];
      this.translations.Digipoort = translation['Request.View.ReceivingEntity.Digipoort'];
      this.translations.SBRNexus = translation['Request.View.ReceivingEntity.SBRNexus'];
    });
  }

  private pkisEventObserver(data: string[], documentGuid: string, inviteGuid: string) {
    this.setPendingStatus(data[0]);
    switch (data[0]) {
      case "getPdfSignatureData":
        this.openIdentificationDialog(inviteGuid);
        break;
      case "changeOfSignatureProviderRequired":
        this.openSignatureProviderDialog();
        break;
      case "authenticateCsc":
        this.signatureProviderUrl = data[1];
        this.ChooseCertificate();
        break;
      case "showMobilePermissionRequest":
        this.SignWithCertificate();
        break;
      case "cscAuthenticated":
        this.ShowPendingDialog();
        break;
      case "downloadData":
        this.signingFinished();
        break;
      case "showAvailableCertificates":
        this.GetAvailableCertificates(data[1]);
        break;
      case "error":
        this.error(data[1]);
        this.viewerDataService.signStartedForDocument = "";
        this.viewerHubService.SignFailed(documentGuid, inviteGuid);
        break;
      case "signatureProviders":
        this.availableSignatureProviders = data[1];
        if (!this.user.isSystemAdmin) {
          for (let i: number = 0; i < this.availableSignatureProviders.length; i++) {
            let dataParameters = this.availableSignatureProviders[i].parameters;
            if (dataParameters && dataParameters[0].indexOf("test") > -1) {
              this.availableSignatureProviders.splice(i, 1);
            }
          }
        }
        if (this.selectedSignatureProvider !== undefined) {
          this.currentSignatureProvider = this.selectedSignatureProvider;
          this.changeSignatureProvider(this.selectedSignatureProvider);
        } else {
          if (!this.user.signatureProvider && !this.user.cscProviderName) {
            this.signatureProviderIndex = this.availableSignatureProviders.findIndex((d: any) => d.signatureProviderType.includes("AdssSignatureProvider"))
          } else if (this.user.signatureProvider === "Token" && !this.user.cscProviderName) {
            this.signatureProviderIndex = this.availableSignatureProviders.findIndex((d: any) => d.signatureProviderType.includes("TokenCertificateSignatureProvider"))
          } else if (this.user.signatureProvider === "HardTokenAgentSignatureProvider" && !this.user.cscProviderName) {
            this.signatureProviderIndex = this.availableSignatureProviders.findIndex((d: any) => d.signatureProviderType.includes("HardTokenAgentSignatureProvider"))
          } else {
            this.signatureProviderIndex = this.availableSignatureProviders.findIndex((d: any) => d.parameters.includes(this.user.cscProviderName));
          }
          if (this.signatureProviderIndex > -1) {
            this.currentSignatureProvider = this.availableSignatureProviders[this.signatureProviderIndex];
          } else {
            this.currentSignatureProvider = this.availableSignatureProviders[0];
          }
        }
        this.suffix = "";
        if (this.currentSignatureProvider.signatureProviderType === 'AdssSignatureProvider') {
          this.eSeal = true;
          this.currentProvider = this.translations.ESeal;
          if (this.currentSignatureProvider.name.indexOf('Pkisigning_') !== 0) {
            this.suffix = (this.currentSignatureProvider.description.split(",")[0]).split("CN=")[1] ? " (" + (this.currentSignatureProvider.description.split(",")[0]).split("CN=")[1] + ")" : "";
          }
        } else if (this.currentSignatureProvider.signatureProviderType === 'TokenCertificateSignatureProvider') {
          this.eSeal = false;
          this.currentProvider = this.translations.Token;
        } else if (this.currentSignatureProvider.signatureProviderType === 'HardTokenAgentSignatureProvider') {
          this.eSeal = false;
          this.currentProvider = this.translations.TokenAgent;
        } else {
          this.eSeal = false;
          this.currentProvider = this.currentSignatureProvider.name;
          if (this.currentSignatureProvider?.parameters && this.currentSignatureProvider?.parameters[0].indexOf('test') > -1) {
            this.suffix = this.suffix + " " + this.translations.Test;
          }
        }

        this.identificationModalRef.componentInstance.eSeal = this.eSeal;
        this.identificationModalRef.componentInstance.signatureProviders = this.availableSignatureProviders;
        this.identificationModalRef.componentInstance.signatureProvider = this.currentSignatureProvider;
        this.identificationModalRef.componentInstance.signatureProviderName = this.currentProvider + this.suffix;
        break;
    }
  }

  public async StartSignAction(event: any) {
    if (this.modalService.hasOpenModals()) {
      return;
    }
    if (this.pkisSubscription) {
      this.pkisSubscription.unsubscribe();
    }
    this.documentId = event.documentId;
    this.viewerHubService.SignStarted(this.documentId, event.inviteGuid);
    this.viewerDataService.signStartedForDocument = this.documentId;
    this.pkisSubscription = this.pkisigning.pkisEvent.subscribe((data) => { this.pkisEventObserver(data, this.documentId, event.inviteGuid) });
    let document = SingleOrDefault(this.request.documentInfo, "id", this.documentId);
    this.OpenPreparingDocumentDialog();
    if (this.request.dossierType.toLocaleLowerCase() === "pdf" || (document && document.documentType == "RegularPdf")) {
      try {
        let sign = await this.actorActionApiClient.initiate_PDF_Signing(this.request.id, this.currentActorInviteId);
        let result = await lastValueFrom(sign);
        this.signingSession = result;
        this.pkisigning.start(result.id, result.password);
      }
      catch (error: any) {
        if (error.status == 424) {
          this.errorHandling("FailedDependency");
        }
      }
    } else {
      try {
        let sign = await this.actorActionApiClient.initiate_XBRL_Signing(this.request.id, this.currentActorInviteId);
        let result: any = await lastValueFrom(sign);
        this.signingSession = result;
        this.pkisigning.start(result.id, result.password);
      }
      catch (error: any) {
        if (error.status == 424) {
          this.errorHandling("FailedDependency");
        }
      }
    }
    this.buttonsEnabled.next(true);
  }

  private OpenPreparingDocumentDialog(): void {
    this.viewerModalService.openPendingDialog(this.translations.PreparingDocument);
  }

  private ChooseCertificate() {
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      windowClass: "authenticate"
    };

    let modalRef: any = null;
    if (document.querySelectorAll('.authenticate').length === 0) {
      this.modalService.dismissAll();
      modalRef = this.modalService.open(PerformActionAuthenticateComponent, ngbModalOptions);
      modalRef.componentInstance.signatureProvider = this.currentSignatureProvider;
      modalRef.componentInstance.signatureProviderUrl = this.signatureProviderUrl;
    }
  }

  private GetAvailableCertificates(data: any) {
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      windowClass: "authenticate"
    };

    let modalRef: any = null;
    if (document.querySelectorAll('.authenticate').length === 0) {
      this.modalService.dismissAll();
      modalRef = this.modalService.open(PerformactioncertificatesComponent, ngbModalOptions);
      modalRef.componentInstance.certificates = data;
      modalRef.componentInstance.request = this.request;
      modalRef.componentInstance.close.subscribe(async (setCertificateToUse: any) => {
        this.pkisigning.selectCertificateToUse(setCertificateToUse);
      });
    }
  }

  private SignWithCertificate() {
    this.ShowPendingDialog();
  }

  private signWithStamp(signatureData: PdfSignatureData) {
    let y: any = this;
    this.engineApiClient.getStamp().subscribe({
      next: (data) => {
        let reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = function () {
          let x = <string>reader.result;
          signatureData.image = x;
          y.pkisigning.setPdfSignatureData(signatureData);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.errorHandling("ErrorDefault");
      }
    });
  }

  private signWithScribble(signatureData: PdfSignatureData, signEvent: any) {
    signatureData.svg = <string>signEvent.signature;
    signatureData.embedTimestampInSvg = signEvent.embedTimestampInSvg;
    this.pkisigning.setPdfSignatureData(signatureData);
  }

  private signWithExistingImage(signatureData: PdfSignatureData, signEvent: any) {
    signatureData.image = localStorage.getItem('SigningImage')!;
    signatureData.embedTimestampInSvg = signEvent.embedTimestampInSvg;
    this.pkisigning.setPdfSignatureData(signatureData);
  }

  private signingFinished() {
    this.ShowPendingDialog();
    let document = SingleOrDefault(this.request.documentInfo, "id", this.documentId);
    if (this.request.dossierType.toLocaleLowerCase() === "pdf" || (document && document.documentType == "RegularPdf")) this.signingFinishedPDF();
    if (this.request.dossierType.toLocaleLowerCase() !== "pdf" && (document && document.documentType != "RegularPdf")) this.signingFinishedXBRL();
  }


  private signingFinishedPDF() {
    this.actorActionApiClient.finish_PDF_Signing(this.RequestId, this.currentActorInviteId, this.signingSession).subscribe({
      next: () => {
        // close the Pending modal
        if (this.modalRef && (this.modalRef.componentInstance as PerformActionPendingModal)) {
          this.modalRef.close();
        }
        // first mark the action complete:
        this.viewerDataService.signStartedForDocument = "";
        this.viewerHubService.SignDone(this.documentId, this.currentActorInviteId);
        this.viewerDataService.actorCompletedAction(this.currentActorInviteId);
        // verify WHICH page needs refreshing:
        let currentPdf: PerformActionDocumentPdfComponent | undefined = this.performactiondocumentpdf.find(s => s.document.id === this.documentId);
        if (currentPdf !== undefined) {
          let actors: DocumentActor[] = currentPdf.document.actors;
          let currentPdfPage: any = actors.find(s => s.fieldName === this.signingSession.signingField)?.sigFieldPage;

          // reload page WITH signature:
          currentPdf.reloadSignaturePage(currentPdfPage)
            .then(async () => {
              currentPdf!.getActionsByPage(currentPdfPage);
              // now stop the SUBSCRIBTIONS FOR SIGNING
              this.pkisSubscription.unsubscribe();
              this.pkisigning.stop();
            })
            .catch((error) => this.loggingService.logException(error));
        }
      },
      error: (error: HttpErrorResponse) => {
        this.errorHandling("ErrorDefault");
      }
    });
  }

  private signingFinishedXBRL() {
    this.actorActionApiClient.finish_XBRL_Signing(this.RequestId, this.currentActorInviteId, this.signingSession).subscribe({
      next: () => {
        // close the Pending modal
        if (this.modalRef && (this.modalRef.componentInstance as PerformActionPendingModal)) {
          this.modalRef.close();
        }
        // first mark the action complete:
        this.viewerDataService.signStartedForDocument = "";
        this.viewerHubService.SignDone(this.documentId, this.currentActorInviteId);
        this.viewerDataService.actorCompletedAction(this.currentActorInviteId);

        // now stop the SUBSCRIBTIONS FOR SIGNING
        this.pkisSubscription.unsubscribe();
        this.pkisigning.stop();
      },
      error: (error: HttpErrorResponse) => {
        this.errorHandling("ErrorDefault");
      }
    });
  }

  private getDCIfAvailable() {
    this.requestService.getRequestForViewer(this.RequestId).subscribe(request => {
      this.request = request;
      this.documents = request.documentInfo;
      if (this.documents.findIndex((p: DocumentModel) => p.documentType == "DetachedSignature") === -1) return;
      this.documentsToShow = this.documents.filter(s => s.documentType.toLocaleLowerCase() != "html" && s.documentType.toLocaleLowerCase() != "generictextfile" && s.documentType.toLocaleLowerCase() != "detachedsignature");
    });
  }


  private elementIsVisibleInViewport(el: any, partiallyVisible = false) {
    const { top, left, bottom, right } = el.getBoundingClientRect();
    const { innerHeight, innerWidth } = window;
    return partiallyVisible
      ? ((top > 0 && top < (innerHeight / 2)) ||
        (bottom > 0 && bottom < (innerHeight / 2))) &&
      ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
      : top >= 0 && left >= 0 && bottom <= (innerHeight / 2) && right <= innerWidth;
  }

  isPartiallyVisible(element: any) {
    return this.elementIsVisibleInViewport(element, true);
  }

  isNotPartiallyVisible(element: any) {
    return this.elementIsVisibleInViewport(element, false);
  }
  public startNextAction() {
    if (!this.actorForNavigation || this.actorForNavigation.id == undefined) {
      return;
    }
    this.awaitAndGotoNextAction(this.actorForNavigation);
  }
  private awaitAndGotoNextAction(toActor: DocumentActor): void {


    // BUILD IN SMALL DELAY TO MAKE SURE CHANGES ARE DONE AND WE DO NOT NAVIGATE TO A 'WRONG' ACTION/MODAL
    setTimeout(() => {
      if (!this.navigateToNextActionAfterCompletion) {
        return;
      }
      if (Is_Sign_Action(toActor.action) && toActor.sigFieldPage > 0) {
        this.scrollToPdfAction(toActor);
      }
      else {
        this.scrollToXbrlAction(toActor.documentId);
      }
    }, 1000);
  }

  private scrollToPdfAction(nextAction: DocumentActor): void {
    let activeSignActionElements = document.getElementsByClassName('active-action');
    if (activeSignActionElements !== null && activeSignActionElements.length > 0) {
      if (!this.isPartiallyVisible(activeSignActionElements[0])) {
        let element = document.getElementById(activeSignActionElements[0].id)!;
        this.centerActionVertically(element);
      }
      return;
    }
    let expectedFieldName = this.viewerDataService.createSigningFieldId(nextAction.documentId, nextAction.fieldName);
    let nextSignElement = document.getElementById(expectedFieldName);
    if (nextSignElement !== null) {
      if (!this.isPartiallyVisible(nextSignElement)) {
        this.centerActionVertically(nextSignElement);
      }
      return;
    }
    if (this.request.status === StatusEnum.PendingApproval) {
      let activeApproveActionElement = document.getElementById(PerformActionConstants.CreateNavigationIdForDocument(nextAction!.documentId));
      if (activeApproveActionElement != null) {
        setTimeout(() => {
          if (!this.isPartiallyVisible(activeApproveActionElement)) {
            if (activeApproveActionElement != null) {
              let element = document.getElementById(activeApproveActionElement.id)!;
              this.centerActionVertically(element);
            }
          }
        }, 1000);
      }
      return;
    }
  }

  private scrollToXbrlAction(documentId: string): void {
    let activeAction = document.getElementById(PerformActionConstants.CreateNavigationIdForDocument(documentId));
    if (activeAction != null) {
      if (!this.isNotPartiallyVisible(activeAction)) {
        let element = document.getElementById(activeAction.id)!;
        this.centerActionVertically(element);
      }
    }
  }





  private error(error: any): void {
    this.pkisSubscription.unsubscribe();
    this.pkisigning.stop();
    this.errorHandling(error);
  }

  private setPendingStatus(engineStatus: string): void {
    switch (engineStatus) {
      case "getPdfSignatureData":
        this.pendingStatus = this.translations.Signing;
        break;
      case "downloadData":
        this.pendingStatus = this.translations.Signed;
        break;
      case "showMobilePermissionRequest":
        this.pendingStatus = this.translations.GivePermissionQTSPApp;
        break;
      case "cscAuthenticated":
        this.pendingStatus = this.translations.Signing;
        break;
      case "error":
        this.modalService.dismissAll();
        break;
    }
  }

  errorHandling(error: string) {
    if (error === "no_certificates" || error === "no_implementation" || error === "no_pkisigningplugin" || error === "user_cancel") {
      this.translateService.get(["Error.Process." + error + "Title"]).subscribe(translation => {
        this.errorTitle = this.translateParser.interpolate(translation["Error.Process." + error + "Title"]);
      });
      this.translateService.get(["Error.Process." + error + "Description"]).subscribe(translation => {
        this.errorDescription = this.translateParser.interpolate(translation["Error.Process." + error + "Description"]);
      });
      this.toastService.showError("" + this.errorTitle + "", "" + this.errorDescription + "");
    } else if (error === "FailedDependency") {
      this.toastService.showError("" + this.translations.ErrorDefault + "", "" + this.translations.FailedDependency + "");
    } else if (error === "ErrorDefault" || error === "ErrorGetActions" || error === "ErrorApprove" || error === "ErrorStartingSignflow") {
      this.translateService.get(["Error." + error + ""]).subscribe(translation => {
        this.errorDescription = this.translateParser.interpolate(translation["Error." + error + ""]);
      });
      this.toastService.showError("" + this.translations.DefaultErrorTitle + "", "" + this.errorDescription + "");
    } else {
      this.translateService.get(["Error.Engine." + error + ""]).subscribe(translation => {
        this.errorDescription = this.translateParser.interpolate(translation["Error.Engine." + error + ""]);
      });
      this.toastService.showError("" + this.translations.EngineErrorDefault + "", "" + this.errorDescription + "");
    }
  }

  openIdentificationDialog(inviteGuid: string) {
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      backdrop: 'static',
      windowClass: "identification"
    };

    if (document.querySelectorAll('.identification').length > 0) return;
    this.modalService.dismissAll();
    this.identificationModalRef = this.modalService.open(PerformActionSignModal, ngbModalOptions);
    if (this.selectedSignatureProvider && this.currentSignatureProvider && this.selectedSignatureProvider != this.currentSignatureProvider) {
      this.changeSignatureProvider(this.selectedSignatureProvider);
    }
    this.identificationModalRef.componentInstance.requestName = this.request.documentInfo.find(doc => doc.id === this.documentId)!.name;
    this.identificationModalRef.componentInstance.request = this.request;
    this.identificationModalRef.componentInstance.owner = this.owner;
    this.identificationModalRef.componentInstance.user = this.user;
    this.identificationModalRef.componentInstance.showStamp = this.showStamp;
    this.identificationModalRef.componentInstance.showDraw = this.showDraw;
    this.identificationModalRef.componentInstance.showPicture = this.showPicture;
    this.identificationModalRef.componentInstance.showReason = this.showReason;
    this.identificationModalRef.componentInstance.showLocation = this.showLocation;
    this.identificationModalRef.componentInstance.eSeal = this.eSeal;
    this.identificationModalRef.componentInstance.sign.subscribe((signEvent: any) => {
      this.identificationModalRef.close();
      this.ShowPendingDialog();
      this.pendingStatus = this.translations.GeneratingSignature;
      let signatureData: PdfSignatureData = new PdfSignatureData();
      signatureData.signatureFields = [];
      if (this.request.actors.filter(p => p.documentId == this.documentId && Is_Sign_Action(p.action) && p.signingDate != null).length == 0) {
        this.request.actors.filter(p => p.documentId == this.documentId && Is_Sign_Action(p.action)).forEach(p => {
          signatureData.signatureFields.push(<EngineSignatureField>{ name: p.fieldName, x: p.sigFieldX, y: p.sigFieldY, width: p.sigFieldW, height: p.sigFieldH, page: p.sigFieldPage })
        });
      }
      signatureData.signatureField = <SignatureField>{ name: this.signingSession.signingField };
      signatureData.lat = "0";
      signatureData.lon = "0";
      signatureData.reason = signEvent.reason;
      signatureData.location = signEvent.location;
      if (signEvent.activeTab === "DigitalStamp") this.signWithStamp(signatureData);
      else if (signEvent.activeTab === "MouseOrTouch") this.signWithScribble(signatureData, signEvent);
      else if (signEvent.activeTab === "UploadPicture") this.signWithExistingImage(signatureData, signEvent);
      this.identificationModalRef.componentInstance.buttonsEnabled = true;

    });
    this.identificationModalRef.componentInstance.signsession.subscribe((value: any) => {
      if (value === "close") {
        this.identificationModalRef.close();
        this.pkisSubscription.unsubscribe();
        this.pkisigning.stop();
        this.viewerHubService.SignFailed(this.documentId, inviteGuid);
      }
    });
    this.identificationModalRef.componentInstance.newSignMethod.subscribe((providerProfile: any) => {
      this.changeSignatureProvider(providerProfile);
      this.currentSignatureProvider = providerProfile;
      this.identificationModalRef.componentInstance.eSeal = this.eSeal;
    });
  }

  openSignatureProviderDialog() {
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      backdrop: 'static',
      windowClass: "identification"
    };

    if (document.querySelectorAll('.identification').length > 0) return;
    this.modalService.dismissAll();
    this.identificationModalRef = this.modalService.open(ChangesignatureproviderModal, ngbModalOptions);
    if (this.selectedSignatureProvider && this.currentSignatureProvider && this.selectedSignatureProvider != this.currentSignatureProvider) {
      this.changeSignatureProvider(this.selectedSignatureProvider);
    }
    this.identificationModalRef.componentInstance.jobname = this.request.documentInfo.find(doc => doc.id === this.documentId)!.name;
    this.identificationModalRef.componentInstance.request = this.request;
    this.identificationModalRef.componentInstance.owner = this.owner;
    this.identificationModalRef.componentInstance.user = this.user;
    this.identificationModalRef.componentInstance.eSeal = this.eSeal;
    this.identificationModalRef.componentInstance.sign.subscribe((signEvent: any) => {
      this.identificationModalRef.close();
      this.ShowPendingDialog();
      this.StartSignAction(signEvent);
    });
    this.identificationModalRef.componentInstance.signsession.subscribe((value: any) => {
      if (value === "close") {
        this.identificationModalRef.close();
        this.pkisSubscription.unsubscribe();
        this.pkisigning.stop();
      }
    });
    this.identificationModalRef.componentInstance.newSignMethod.subscribe((providerProfile: any) => {
      this.currentSignatureProvider = providerProfile;
      this.identificationModalRef.componentInstance.eSeal = this.eSeal;
    });

  }

  changeSignatureProvider(providerProfile: any) {
    this.pkisigning.changeSignatureProvider(providerProfile.signatureProviderType, providerProfile.parameters);
    this.selectedSignatureProvider = providerProfile;
    if (this.selectedSignatureProvider.signatureProviderType === 'AdssSignatureProvider') {
      this.eSeal = true;
    } else {
      this.eSeal = false;
    }
  }


  async getHtml(doc: DocumentModel) {
    try {
      let getDoc = await this.documentService.getHtmlDetails(this.request.id, doc.id);
      let document: any = await lastValueFrom(getDoc);
      if (document === null) return;
      doc.fileSize = document.documentSize;
      this.request.documentInfo.filter(s => s.id === doc.id)[0].fileSize = doc.fileSize;
    }
    catch (error) {
      this.toastService.showError("" + this.translations.error + "", "" + this.translations.toastsGetDocumentError + "");
    }
  }



  stopAndUnsubscribe() {
    this.pkisSubscription.unsubscribe();
    this.pkisigning.stop();
  }

  ShowPendingDialog() {
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      backdrop: 'static',
      windowClass: "pending"
    };
    if (this.isShowingAFinalPage) {
      return;
    }
    if (!this.modalRef || !(this.modalRef.componentInstance as PerformActionPendingModal)) {
      this.modalService.dismissAll();
      this.modalRef = this.modalService.open(PerformActionPendingModal, ngbModalOptions);
    }
    (this.modalRef.componentInstance as PerformActionPendingModal).displayMessage = this.pendingStatus;
  }

  RequestUnavailableDialog() {
    let ngbModalOptions: NgbModalOptions = {
      keyboard: false,
      centered: true,
      size: 'md',
      backdrop: 'static',
      fullscreen: true,
      windowClass: 'overlay-fullscreen'
    };
    this.modalService.dismissAll();
    this.viewerHubService.stop();
    this.modalRef = this.modalService.open(DisplayRequestUnavailableModal, ngbModalOptions);
  }

  zoom(factor: any) {
    this.zoomFactor = factor;
    this.columnsLg = this.defaultColumnsLg + (this.zoomFactor * 2);
    this.columnsXl = this.defaultColumnsXl + (this.zoomFactor * 2);
    this.zoomPageElementId = this.getCurrentPageElementId();
    setTimeout(() => {
      if (this.zoomPageElementId) {
        let e = <HTMLElement>document.getElementById(this.zoomPageElementId);
        e.scrollIntoView({ behavior: "auto" });
      }
    }, 100);
  }

  private elementInViewport(element: HTMLElement) {
    let bounding = element.getBoundingClientRect();
    let x = (
      bounding.bottom < 135 + 0.3 * (window.innerHeight || document.documentElement.clientHeight) ||
      bounding.top > (window.innerHeight || document.documentElement.clientHeight)
    );
    return !x;
  }

  /**
   * Finds the FIRST 'page' Element Id that is visible in viewport
   * @returns the Id or NULL
   */
  getCurrentPageElementId(): string | null {
    let visiblePageId: string | null = null;
    this.request.documentInfo.forEach(doc => {
      for (let pageId: number = 1; pageId <= doc.pages; pageId++) {
        let pageElementId = doc.id + "_" + pageId + "_indicator";
        let pageElement: HTMLElement = <HTMLElement>document.getElementById(pageElementId);
        if (this.elementInViewport(pageElement) && visiblePageId != null) {
          visiblePageId = pageElementId;
        }
      }
    });
    return visiblePageId;
  }



  centerActionVertically(element: HTMLElement) {
    this.paddingBelowLastPage = (window.innerHeight || document.documentElement.clientHeight);
    setTimeout(() => {
      element.scrollIntoView({ block: 'center', behavior: "smooth", inline: "nearest" });
    }, 100);
  }


  // private signatureFieldInViewport(signaturefieldElement: HTMLElement) {
  //   let bounding = signaturefieldElement.getBoundingClientRect();
  //   let hasBottomAndTopOutsideOfScreenBounderies = (
  //     // verifies top, by checking IF your bottom is outside of the top header
  //     // we do 0.1 for the header
  //     bounding.bottom < 0.1 * (window.innerHeight || document.documentElement.clientHeight) ||
  //     // verifies bottom, if your top is inside the screen
  //     // we SUBSTRACT a 0.1 header
  //     bounding.top > ((window.innerHeight || document.documentElement.clientHeight) - (0.1 * (window.innerHeight || document.documentElement.clientHeight)))
  //   );
  //   // inverse it!
  //   return !hasBottomAndTopOutsideOfScreenBounderies;
  // }

  private setViewerToCompleted() {
    if (this.viewerDataService.generateDC) {
      this.getDCIfAvailable();
    }
    if (!this.isShowingAFinalPage && this.viewerService.hasUncompletedActions) {
      this.isShowingAFinalPage = true;
      this.displayAsPerformActionPage = false;
      this.viewerModalService.openRequestcompletedModal();
    }
  }
}
